export default __webpack_public_path__ + "static/1035-3b2b096b995ae1c64f73443f31ece60d.gif";